module.exports = "https://deal-img.imgix.net/consumer/modern/golfer.c73d2106.jpg";